export default __webpack_public_path__ + "static/media/xpf.17a60163.jpg";